import React from 'react'

function Followers() {
  return (
    <div>
         {/* Accounts following user */}
    </div>
  )
}

export default Followers
